/**
 * Base class for a type of {@code Model} that maintains a list of items, triggers an
 * {@link #ON_LIST_CHANGE_EVENT} when the list changes, and triggers an {@link #ON_SELECTION_EVENT}
 * when the item selection changes. Only a single item can be selected at any time.
 */
import { EventEmitter } from 'events';

export default class SelectableItemModel extends EventEmitter {

  constructor() {
    super();

    // Define the events fired by this model.
    this.ON_SELECTION_EVENT = 'onSelect';
    this.ON_LIST_CHANGE_EVENT = 'onListChange';

    // Define the internal cache if it hasn't already been defined.
    this._internalCache = this._internalCache || [];

    // Define the selected item property.
    this._selectedItem = undefined;
    // Select the first item if no item is already selected.
    this._selectedItem =
      (!this._selectedItem && this._internalCache.length > 0) ?
        this._internalCache[0] :
        undefined;

  }

  /**
   * Accessor for retrieving the list of items.
   */
  getItems() {
    return this._internalCache;
  }

  /**
   * Accessor for retrieving the selected item.
   */
  getSelectedItem() {
    return this._selectedItem;
  }

  /**
   * Setter for the selected item. This method fires an {@link #ON_SELECTION_EVENT}.
   */
  setSelectedItem(item) {
    this._selectedItem = item;
    this.emit(this.ON_SELECTION_EVENT, this._selectedItem);
  }

}



// WEBPACK FOOTER //
// ./src/app/models/selectable-item-model.js